import { ContentLayout } from '@metorial/layout';
import { Outlet } from 'react-router-dom';
import { DashboardShell } from '../../../shell';

// Settings area (cloud-spec §7): the BlackOS shell with the settings sub-nav
// (Home · Organization · Project · Integrations and MCP · Workforce · Skills).
export let OrganizationPageLayout = () => (
  <DashboardShell>
    <ContentLayout>
      <Outlet />
    </ContentLayout>
  </DashboardShell>
);
